import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AppDispatch } from "../../configureStore";
import { Applicant, signInUser } from "../../redux/reducer/applicant";
import { AxiosResponse } from "axios";
import { Spin } from "antd";
import { storeTokens } from "../../utils/tokenStore";

interface MagicLinkPageParams {
}

const MagicLinkPage = ({
}: MagicLinkPageParams) => {
    const dispatch = useDispatch<AppDispatch>();
    const [params] = useSearchParams();
    const navigate = useNavigate();

    const getAuth = useCallback(() => {
        const token = params.get('token');
        const check = params.get('check');

        if (token && check) {
            dispatch(signInUser({
                input: {
                    l: encodeURIComponent(window.location.host),
                    token,
                    check,
                },
                onSuccess: (res: AxiosResponse<{ tokens: { accessToken: string; refreshToken: string; }; applicant: Applicant; }>) => {
                    storeTokens(res.data.tokens);
                    navigate('/')
                }
            }));
        }
    }, [params]);

    const hasCalled = useRef(false);

    useEffect(() => {
        if (hasCalled.current) return;
        hasCalled.current = true;

        getAuth();
    }, []);

    return <Spin fullscreen />;
};

export default MagicLinkPage;
